import { NgModule } from "@angular/core";
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { SigninComponent } from './auth/signin/signin.component';
import { ForgotpasswordComponent } from './auth/forgotpassword/forgotpassword.component';
import { ResetpasswordComponent } from './auth/resetpassword/resetpassword.component';
import { AppLayoutComponent } from './layout/app-layout/app-layout.component';
import { BasicinfoComponent } from './basicinfo/basicinfo.component';
import { TechnicianComponent } from './technician/technician.component';
import { EquipmentsComponent } from './equipments/equipments.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { VacationManagementComponent } from './vacation-management/vacation-management.component';
import { ProfilePhotosComponent } from './profile-photos/profile-photos.component';
import { InsuranceComponent } from './insurance/insurance.component';
import { FrontDeskComponent } from './front-desk/front-desk.component';
import { TimeSlotSettingsComponent } from './time-slot-settings/time-slot-settings.component';
import { MedicalQuestionsComponent } from './medical-questions/medical-questions.component';
import { VacationHistoryComponent } from './vacation-history/vacation-history.component';
import { ResponsiveLandingComponent } from './responsive-landing/responsive-landing.component';
import { ScheduleFormComponent } from './schedule-form/schedule-form.component';
import { BottomButtonsComponent } from './bottom-buttons/bottom-buttons.component';
import { ProfileFormComponent } from './profile-form/profile-form.component';
import { PreAuthorieComponent } from './pre-authorie/pre-authorie.component';
import { PreAuthorizeComponent } from './pre-authorize/pre-authorize.component';
import { PreAutho2Component } from './pre-autho2/pre-autho2.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { AppointmentConfirmComponent } from './appointment-confirm/appointment-confirm.component';
import { ThankyouComponent } from './thankyou/thankyou.component';
import { PatientProfileComponent } from './patient-profile/patient-profile.component';
import { MissingDetailsComponent } from './missing-details/missing-details.component';
import { SelectionScreenComponent } from './selection-screen/selection-screen.component';
import { HamSidemenuComponent } from './ham-sidemenu/ham-sidemenu.component';
import { SubpageComponent } from './subpage/subpage.component';
import { SchedLayoutComponent } from './schedmed-layout/sched-layout/sched-layout.component';
import { ConfirmingDetailsComponent } from './confirming-details/confirming-details.component';
import { WaitingListComponent } from './waiting-list/waiting-list.component';
import { CancelNoshowComponent } from './cancel-noshow/cancel-noshow.component';
import { CheckInPatientComponent } from './check-in-patient/check-in-patient.component';
import { ScheduleAppointmentComponent } from './schedule-appointment/schedule-appointment.component';
import { CreditCardComponent } from './credit-card/credit-card.component';
import { BillingReportsComponent } from './billing-reports/billing-reports.component';
import { HoldOrCancelComponent } from './hold-or-cancel/hold-or-cancel.component';
import { BillingSummaryComponent } from './billing-summary/billing-summary.component';
import { PlanSubscriptionComponent } from './plan-subscription/plan-subscription.component';
import { MetroComponent } from './metro/metro.component';
import { RegionComponent } from './region/region.component';
import { HomeCalenderComponent } from './home-calender/home-calender.component';
import { TechnicianScheduleComponent } from './technician-schedule/technician-schedule.component';
import { PatientInfoComponent } from './patient-info/patient-info.component';
import { AuthorizationStatusComponent } from './authorization-status/authorization-status.component';
import { PhysicianInformationComponent } from './physician-information/physician-information.component';
import { PatientReviewComponent } from './patient-review/patient-review.component';
import { CheckedInPatientComponent } from './checked-in-patient/checked-in-patient.component';
// import { RescheduledPatientComponent } from './rescheduled-patient/rescheduled-patient.component';

import { NoshowPatientComponent } from './noshow-patient/noshow-patient.component';
import { CancelledReportComponent } from './cancelled-report/cancelled-report.component';
import { InsuranceBillingComponent } from './insurance-billing/insurance-billing.component';
import { ReportLogComponent } from './report-log/report-log.component';
import { WorkHoursComponent } from './work-hours/work-hours.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsComponent } from './terms/terms.component';
import { HelpComponent } from './help/help.component';
import { SchedmedPatientComponent } from './schedmed-patient/schedmed-patient.component';
import { ImagingCenterPatientsComponent } from './imaging-center-patients/imaging-center-patients.component';
import { CancelAppointmentsComponent } from './cancel-appointments/cancel-appointments.component';
import { ScheduleReviewComponent } from './schedule-review/schedule-review.component';
import { BillingLogComponent } from './billing-log/billing-log.component';
import { BillingErrorsComponent } from './billing-errors/billing-errors.component';
import { SchedmedReviewComponent } from './schedmed-review/schedmed-review.component';
import { ImagingComponent } from './imaging/imaging.component';
import { PatientListComponent } from './patient-list/patient-list.component';
import { InsuranceCompaniesComponent } from './insurance-companies/insurance-companies.component';
import { TechnologistComponent } from './technologist/technologist.component';
import { DoctorListComponent } from './doctor-list/doctor-list.component';
import { ManageImagingCenterComponent } from './manage-imaging-center/manage-imaging-center.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { UtilizationComponent } from './utilization/utilization.component';
import { EquipmentBreakdownComponent } from './equipment-breakdown/equipment-breakdown.component';
import { CallsUsingSchedmedComponent } from './calls-using-schedmed/calls-using-schedmed.component';
import { AnalysisAppointmentsComponent } from './analysis-appointments/analysis-appointments.component';
import { AccessManagementComponent } from './access-management/access-management.component';
import { WaitingListHistoryComponent } from './waiting-list-history/waiting-list-history.component';
import { LocationFindComponent } from './location-find/location-find.component';
import { MessageCenterComponent } from './message-center/message-center.component';
import { PatientEditComponent } from './patient-edit/patient-edit.component';
import { RescheduledPatientComponent } from './rescheduled-patient/rescheduled-patient.component';
import { DetailPageComponent } from './detail-page/detail-page.component';
import { PatientNotificationsComponent } from './patient-notifications/patient-notifications.component';
import { DownloadAppComponent } from './download-app/download-app.component';
import { DownloadAppIosComponent } from './download-app-ios/download-app-ios.component';
const routes: Routes = [
  { path: 'login', component: SigninComponent },
  { path: 'forgotpassword', component: ForgotpasswordComponent },
  { path: 'resetpassword', component: ResetpasswordComponent },
  { path: 'ham-sidemenu', component: HamSidemenuComponent },
  {
    path: '',
    component: SchedLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      { path: 'home', component: HomeComponent },
      { path: 'home/:id', component: HomeComponent },
      { path: 'responsive-landing', component: ResponsiveLandingComponent },
      { path: 'schedule-form', component: ScheduleFormComponent },
      { path: 'schedule-form/:id', component: ScheduleFormComponent },
      { path: 'bottom-buttons', component: BottomButtonsComponent },
      { path: 'profile-form', component: ProfileFormComponent },
      { path: 'profile-form/:id', component: ProfileFormComponent },
      { path: 'pre-authorie', component: PreAuthorieComponent },
      { path: 'pre-authorie/:id', component: PreAuthorieComponent },
      { path: 'pre-authorize/:id', component: PreAuthorizeComponent },
      { path: 'pre-autho2/:id', component: PreAutho2Component },
      { path: 'appointment/:id', component: AppointmentComponent },
      { path: 'download-app', component: DownloadAppComponent },
      { path: 'download-app-ios', component: DownloadAppIosComponent },

      {
        path: 'appointment-confirm/:id',
        component: AppointmentConfirmComponent,
      },
      { path: 'thankyou', component: ThankyouComponent },
      { path: 'thankyou/:id', component: ThankyouComponent },
      { path: 'patient-profile/:id', component: PatientProfileComponent },
      { path: 'missing-profile/:id', component: MissingDetailsComponent },
      { path: 'selection-screen', component: SelectionScreenComponent },
      { path: 'selection-screen/:id', component: SelectionScreenComponent },
      { path: 'subpage', component: SubpageComponent },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'terms', component: TermsComponent },
      { path: 'help', component: HelpComponent },
      { path: 'schedule-review', component: ScheduleReviewComponent },
      { path: 'schedule-review/:id', component: ScheduleReviewComponent },
      { path: 'location', component: LocationFindComponent },
      { path: 'detail-page', component: DetailPageComponent },
      { path: 'detail-page/:id', component: DetailPageComponent },
    ],
  },
  { path: 'metro/:countryCode', component: MetroComponent },
  { path: 'region/:stateId', component: RegionComponent },
  {
    path: '',
    component: AppLayoutComponent,
    children: [
      { path: ':id/basicinfo', component: BasicinfoComponent },
      { path: ':id/technician', component: TechnicianComponent },
      { path: ':id/equipments', component: EquipmentsComponent },
      { path: ':id/procedure', component: ProcedureComponent },
      { path: ':id/vacation-management',component: VacationManagementComponent},
      { path: ':id/profile-photos', component: ProfilePhotosComponent },
      { path: ':id/insurance', component: InsuranceComponent },
      { path: ':id/time-slot-settings', component: TimeSlotSettingsComponent },
      { path: ':id/medical-questions', component: MedicalQuestionsComponent },
      { path: ':id/vacation-history', component: VacationHistoryComponent },
      { path: ':id/front-desk', component: FrontDeskComponent },
      { path: ':id/home-calendar', component: HomeCalenderComponent },
      { path: ':id/patient-info', component: PatientInfoComponent },
      { path: ':id/confirming-details', component: ConfirmingDetailsComponent },
      { path: ':id/waiting-list', component: WaitingListComponent },
      { path: ':id/cancel-noshow', component: CancelNoshowComponent },
      { path: ':id/check-in-patient', component: CheckInPatientComponent },
      {path: ':id/schedule-appointment',component: ScheduleAppointmentComponent},
      { path: ':id/credit-card', component: CreditCardComponent },
      { path: ':id/billing-reports', component: BillingReportsComponent },
      { path: ':id/hold-or-cancel', component: HoldOrCancelComponent },
      { path: ':id/billing-summary', component: BillingSummaryComponent },
      { path: ':id/plan-subscription', component: PlanSubscriptionComponent },
      {
        path: ':id/cancel-noshow/:patientID',
        component: CancelNoshowComponent,
      },
      {
        path: ':id/schedule-appointment/:patientID',
        component: ScheduleAppointmentComponent,
      },
      {
        path: ':id/check-in-patient/:patientID',
        component: CheckInPatientComponent,
      },
      { path: ':id/waiting-list/:patientID', component: WaitingListComponent },
      {
        path: ':id/technician-schedule',
        component: TechnicianScheduleComponent,
      },
      {
        path: ':id/authorization-status',
        component: AuthorizationStatusComponent,
      },
      {
        path: ':id/physician-information',
        component: PhysicianInformationComponent,
      },
      { path: ':id/patient-review', component: PatientReviewComponent },
      { path: ':id/checked-in-patient', component: CheckedInPatientComponent },

      // { path: ':id/rescheduled-patient', component: RescheduledPatientComponent },

      { path: ':id/noshow-patient', component: NoshowPatientComponent },
      { path: ':id/cancelled-report', component: CancelledReportComponent },
      { path: ':id/insurance-billing', component: InsuranceBillingComponent },
      { path: ':id/report-log', component: ReportLogComponent },
      { path: ':id/work-hours', component: WorkHoursComponent },
      { path: ':id/schedmed-patient', component: SchedmedPatientComponent },
      {
        path: ':id/imaging-center-patients',
        component: ImagingCenterPatientsComponent,
      },
      {
        path: ':id/cancel-appointments',
        component: CancelAppointmentsComponent,
      },
      { path: ':id/billing-log', component: BillingLogComponent },
      { path: ':id/billing-errors', component: BillingErrorsComponent },
      { path: ':id/schedmed-review', component: SchedmedReviewComponent },
      { path: ':id/imaging', component: ImagingComponent },
      { path: ':id/patient-list', component: PatientListComponent },
      {
        path: ':id/insurance-companies',
        component: InsuranceCompaniesComponent,
      },
      { path: ':id/technologist', component: TechnologistComponent },
      { path: ':id/doctor-list', component: DoctorListComponent },
      { path: ':id/dashboard', component: DashboardComponent },
      { path: ':id/admin/dashboard', component: DashboardComponent },
      { path: ':id/admin/imaging', component: ImagingComponent },
      { path: ':id/admin/patient-list', component: PatientListComponent },
      {
        path: ':id/admin/insurance-companies',
        component: InsuranceCompaniesComponent,
      },
      { path: ':id/admin/technologist', component: TechnologistComponent },
      { path: ':id/admin/doctor-list', component: DoctorListComponent },
      { path: ':id/admin/billing-log', component: BillingLogComponent },
      { path: ':id/admin/billing-errors', component: BillingErrorsComponent },
      {
        path: ':id/admin/manage-imaging-center',
        component: ManageImagingCenterComponent,
      },
      { path: ':id/admin/schedmed-review', component: SchedmedReviewComponent },
      { path: ':id/admin/report-menu', component: DoctorListComponent },
      {
        path: ':id/manage-imaging-center',
        component: ManageImagingCenterComponent,
      },
      { path: ':id/utilization', component: UtilizationComponent },
      {
        path: ':id/equipment-breakdown',
        component: EquipmentBreakdownComponent,
      },
      {
        path: ':id/calls-using-schedmed',
        component: CallsUsingSchedmedComponent,
      },
      {
        path: ':id/analysis-appointments',
        component: AnalysisAppointmentsComponent,
      },
      { path: ':id/access-management', component: AccessManagementComponent },
      {
        path: ':id/waiting-list-history',
        component: WaitingListHistoryComponent,
      },
      {
        path: ':id/waiting-list-history',
        component: WaitingListHistoryComponent,
      },
      { path: ':id/message-center', component: MessageCenterComponent },
      { path: ':id/report-menu', component: DoctorListComponent },
      { path: ':id/patient-edit', component: PatientEditComponent },
      {
        path: ':id/rescheduled-patient',
        component: RescheduledPatientComponent,
      },
      {
        path: ':id/patient-notifications',
        component: PatientNotificationsComponent,
      },
    ],
  },
  {path: '**', redirectTo: '/subpage'}
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
      scrollOffset: [0, 64], // [x, y],
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
